import {
  FAQS_LIST_LOADING,
  GET_FAQS_LIST_ERROR,
  GET_FAQS_LIST,
  GET_FAQS_BY_ID_LOADING,
  GET_FAQS_BY_ID_SUCCESS,
  GET_FAQS_BY_ID_ERROR,
  DELETEING_FAQS,
  DELETE_FAQS,
  DELETE_FAQS_ERROR,
  DELETED_FAQS_LIST_LOADING,
  GET_DELETED_FAQS_LIST,
  GET_DELETED_FAQS_LIST_ERROR,
  PERMA_DELETEING_FAQS,
  PERMA_DELETE_FAQS,
  PERMA_DELETE_FAQS_ERROR,
  RESTORE_FAQS_LIST_LOADING,
  RESTORE_FAQS_LIST,
  RESTORE_FAQS_LIST_ERROR,
} from "./types";

const INITIAL_STATE = {
  data: undefined,
  loading: false,
  error: false,
  dataById: undefined,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FAQS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_FAQS_BY_ID_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETEING_FAQS:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETED_FAQS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case PERMA_DELETEING_FAQS:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case RESTORE_FAQS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case GET_FAQS_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case GET_FAQS_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        dataById: action.payload.data,
        error: false,
      };
    case GET_DELETED_FAQS_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case DELETE_FAQS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case PERMA_DELETE_FAQS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case RESTORE_FAQS_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case GET_FAQS_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_FAQS_BY_ID_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_DELETED_FAQS_LIST_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case DELETE_FAQS_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case PERMA_DELETE_FAQS_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case RESTORE_FAQS_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };

    default:
      return state;
  }
};

export default reducer;